import React from 'react';
import { GlassCard } from '../../../_shared/GlassCard';
import { Mic, Film, Layers, Wand2 } from 'lucide-react';
import { BUILT } from '../data';

const ICONS = { mic: Mic, film: Film, layers: Layers, wand: Wand2 };

export const BuiltThisMonth = () => {
    return (
        <section className="py-16 px-4">
            <div className="container mx-auto max-w-6xl">
                <p className="text-white/40 text-xs uppercase tracking-[0.2em] font-semibold text-center mb-3">Production</p>
                <h2 className="text-3xl md:text-4xl font-bold text-white mb-3 text-center">What We Built This Month</h2>
                <p className="text-white/50 text-center mb-12 max-w-xl mx-auto">
                    Everything shipped between {BUILT.windowLabel}.
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                    {BUILT.items.map((item, i) => {
                        const Icon = ICONS[item.icon] || Film;
                        return (
                            <GlassCard key={i}>
                                <div className="flex items-start gap-5">
                                    <div className="bg-purple-500/20 text-purple-300 p-3 rounded-xl inline-flex shrink-0">
                                        <Icon size={20} />
                                    </div>
                                    <div>
                                        <p className="text-white font-bold text-base mb-1">{item.title}</p>
                                        <p className="text-white/55 text-sm leading-snug">{item.body}</p>
                                    </div>
                                </div>
                            </GlassCard>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};
